import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/utils/lib";

export const PostCommentSkeletonList = ({
  count = 4,
  withLeadingBorder = false,
}: {
  count?: number;
  withLeadingBorder?: boolean;
}) => {
  const primaryWidths = ["w-[118px]", "w-[92px]", "w-[132px]", "w-[104px]"];
  const metaWidths = ["w-[88px]", "w-[74px]", "w-[96px]", "w-[82px]"];
  const bodyWidths = ["w-[92%]", "w-[82%]", "w-[88%]", "w-[76%]"];
  const bodySecondaryWidths = ["w-[68%]", "w-[58%]", "w-[64%]", "w-[54%]"];

  return Array.from({ length: count }, (_, index) => (
    <div
      key={index}
      className={cn("unforce-radius relative w-full px-4 pt-4 pb-3", {
        "border-t border-border-light": withLeadingBorder || index > 0,
      })}
    >
      <div
        className="
          space-y-3
          md:hidden
        "
      >
        <div className="flex items-start gap-3">
          <Skeleton className="mt-0.5 size-10 shrink-0 rounded-full" />
          <div className="min-w-0 flex-1 space-y-2">
            <div className="flex items-start gap-2">
              <div className="min-w-0 flex-1 space-y-1.5">
                <Skeleton className={cn("h-4", primaryWidths[index % 4])} />
                <div className="flex items-center gap-2">
                  <Skeleton className={cn("h-3", metaWidths[index % 4])} />
                  <Skeleton className="h-3 w-[36px]" />
                </div>
              </div>
              <Skeleton className="mt-1 size-4 rounded-full" />
            </div>
          </div>
        </div>
        <div className="space-y-2">
          <Skeleton className={cn("h-4", bodyWidths[index % 4])} />
          <Skeleton className={cn("h-4", bodySecondaryWidths[index % 4])} />
        </div>
        <div className="flex justify-end gap-2 pr-1">
          <Skeleton className="size-5 rounded-full" />
          <Skeleton className="size-5 rounded-full" />
        </div>
        <div className="flex items-center gap-4">
          <Skeleton className="size-3.5 rounded-full" />
          <Skeleton className="size-3.5 rounded-full" />
          <Skeleton className="size-3.5 rounded-full" />
          <Skeleton className="size-3.5 rounded-full" />
          <Skeleton className="size-3.5 rounded-full" />
          <Skeleton className="ml-auto h-3.5 w-4" />
        </div>
      </div>
      <div
        className="
          hidden items-start gap-3
          md:flex
        "
      >
        <Skeleton className="mt-0.5 size-10 shrink-0 rounded-full" />
        <div className="min-w-0 flex-1 space-y-3">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <Skeleton className={cn("h-4", primaryWidths[index % 4])} />
              <Skeleton className="h-3 w-[64px]" />
            </div>
            <Skeleton className={cn("h-4", bodyWidths[index % 4])} />
            <Skeleton className={cn("h-4", bodySecondaryWidths[index % 4])} />
          </div>
          <div
            className="
              hidden items-center gap-4
              md:flex
            "
          >
            <Skeleton className="h-3.5 w-[42px]" />
            <Skeleton className="size-3.5 rounded-full" />
            <Skeleton className="size-3.5 rounded-full" />
            <Skeleton className="size-3.5 rounded-full" />
            <Skeleton className="h-3.5 w-4" />
          </div>
        </div>
      </div>
    </div>
  ));
};
